import { en_us } from "./i18n/en_us/i18n_en_us"
import { es } from "./i18n/es/i18n_es"

export const dict = {
    en_us,
    es,
}